/* eslint-disable camelcase */
import axios from 'axios'
import { getToken, getLeaderFlag } from '@/utils/auth'

// 创建 axios 实例
const service = axios.create({
  // baseURL: 'http://106.37.214.65:8082/ssxh', // 外网开发
  baseURL: 'http://111.205.106.65:8080/ssxh', // 外网测试
  // baseURL: 'http://106.37.214.65:8081/ssxh', // 外网回归
  // baseURL: 'https://simpmprd.newchinalife.com/ssxh', // 生产
  // baseURL: 'http://10.5.103.133:8080/ssxh', // 杨杰
  // baseURL: 'http://10.5.75.31:8686/ssxh', // 崔亚非
  // baseURL: 'http://10.5.75.3:8083/ssxh', // 别俊熠
  // baseURL: 'http://10.5.75.64:8080/ssxh', // 赵辉
  // baseURL: 'http://192.168.180.222:8082/ssxh', // 内网开发
  // baseURL: 'http://10.1.128.87:8082/ssxh', // nginx内网开发
  // baseURL: 'http://10.1.128.87:8080/ssxh', // nginx内网测试
  timeout: 60000 // 请求超时时间
})

// const smartbiUrl = 'http://106.37.214.65:8082/smartbi' // smartbi外网开发地址
// const smartbiLeaderUrl = 'http://106.37.214.65:8082/smartbi' // smartbi外网开发地址
const smartbiUrl = 'http://111.205.106.65:8080/smartbi' // smartbi外网测试地址
const smartbiLeaderUrl = 'http://111.205.106.65:8080/smartbi' // smartbi外网测试地址
// const smartbiUrl = 'http://106.37.214.65:8081/smartbi' // smartbi外网回归地址
// const smartbiLeaderUrl = 'http://106.37.214.65:8081/smartbi' // smartbi外网回归地址
// const smartbiUrl = 'https://simpmprd.newchinalife.com/smartbi' // smartb生产
// const smartbiLeaderUrl = 'https://simpmprd.newchinalife.com/smartbi' // smartb生产
// const smartbiUrl = 'http://10.1.104.24:81/smartbi' // smartb内网网地址
// const smartbiLeaderUrl = 'http://10.1.104.24:81/smartbi' // smartb内网网地址
// const smartbiUrl = 'http://192.168.180.222:8081/smartbi' // smartbi内网开发地址
// const smartbiLeaderUrl = 'http://192.168.180.222:8081/smartbi' // smartbi内网开发地址
// const smartbiUrl = 'http://10.1.128.87:8082/smartbi' // smartbi内网nginx开发地址
// const smartbiLeaderUrl = 'http://10.1.128.87:8082/smartbi' // smartbi内网nginx开发地址
// const smartbiUrl = 'http://10.1.128.87:8080/smartbi' // smartbi内网nginx测试地址
// const smartbiLeaderUrl = 'http://10.1.128.87:8080/smartbi' // smartbi内网nginx测试地址

// const ygkbJumpUrl = 'https://jxtest.newchinalife.com:8443/#/leadershipRank' // 员工看板跳转回归地址
const ygkbJumpUrl = 'https://jxtest.newchinalife.com/#/leadershipRank' // 员工看板跳转测试地址
// const ygkbJumpUrl = 'https://jxgl.newchinalife.com/#/leadershipRank' // 员工看板跳转生产地址

// const ygkbDandianJumpUrl = 'https://ssotest.newchinalife.com/ddAppAuth.html?appCode=YGKBper&type=app' // 员工看板单点登录回归地址
const ygkbDandianJumpUrl = 'https://ssotest.newchinalife.com/ddAppAuth.html?appCode=YGKBtest&type=app' // 员工看板单点登录测试地址
// const ygkbDandianJumpUrl = 'http://sso.newchinalife.com/ddAppAuth.html?appCode=YGMB&type=app' // 员工看板单点登录生产地址
function getSmartbiUrl () {
  var leaderFlag = 0
  // -------------------------------smartbi 领导分发服务器 xxx---------------------------
  leaderFlag = getLeaderFlag()
  // -------------------------------smartbi 领导分发服务器 end ---------------------------
  var url = smartbiUrl
  if (leaderFlag) {
    url = smartbiLeaderUrl
  }
  return url
}
function getSmartbiLeadFlag () {
  var leaderFlag = 0
  // -------------------------------smartbi 领导分发服务器 xxx---------------------------
  leaderFlag = getLeaderFlag()
  // -------------------------------smartbi 领导分发服务器 end ---------------------------
  return leaderFlag
}
function getSmartbiUserToken () {
  var userToken = ''
  // -------------------------------smartbi 用户token start---------------------------
  userToken = getToken()
  // -------------------------------smartbi 用户token end ---------------------------
  return userToken
}
const err = () => {
}

service.interceptors.request.use(config => {
  if (getToken()) {
    config.headers[ 'token' ] = getToken()
    config.headers[ 'leadFlag' ] = getLeaderFlag()
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
  return response.data
}, err)

export {
  service as axios,
  smartbiUrl,
  smartbiLeaderUrl,
  ygkbJumpUrl,
  getSmartbiUrl,
  getSmartbiLeadFlag,
  getSmartbiUserToken,
  ygkbDandianJumpUrl
}



// WEBPACK FOOTER //
// ./src/utils/request.js